export enum ResponseStatus {
  OK = 0,
  FAIL = 2,
  SERVER_ERROR = -1,
  ERROR_VALIDATION = -3,
  ERROR_PROFILE_AMOUNT = -2,
  TOKEN_EXPIRED = -4,
}
